import { Badge, Card, CardContent } from '@estac1/ui';
import type { UseMutationResult } from '@tanstack/react-query';
import { ClientLotRow } from './client-lot-row.js';
import type { ModuleToggleMutation, ToggleableModuleKey } from './lot-module-toggles.js';
import type { Client, Lot, PricingSettings } from './types.js';
import { formatDate } from './utils.js';

interface ClientCardProps {
  client: Client;
  pricing: PricingSettings | undefined;
  onExtend: (lot: Lot) => void;
  onArchive: (lot: Lot) => void;
  onUnarchive: (lot: Lot) => void;
  onResetCheckout: (lot: Lot) => void;
  onToggleModule: (lot: Lot, key: ToggleableModuleKey, enabled: boolean) => void;
  unarchive: UseMutationResult<unknown, unknown, string, unknown>;
  toggleModule: ModuleToggleMutation;
  resetCheckout: UseMutationResult<unknown, unknown, string, unknown>;
}

export const ClientCard = ({
  client,
  pricing,
  onExtend,
  onArchive,
  onUnarchive,
  onResetCheckout,
  onToggleModule,
  unarchive,
  toggleModule,
  resetCheckout,
}: ClientCardProps) => (
  <Card className={client.archivedAt ? 'opacity-60' : undefined}>
    <CardContent className="space-y-3 pt-6">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <p className="font-semibold">
            {client.name}
            {client.archivedAt && (
              <Badge variant="default" className="ml-2 align-middle">
                arquivado
              </Badge>
            )}
          </p>
          <p className="text-sm text-muted-fg">{client.email}</p>
        </div>
        <p className="text-xs text-muted-fg">
          desde {formatDate(client.createdAt)}
          {client.signupOrigin && ` · veio de /${client.signupOrigin}`}
        </p>
      </div>

      {client.lots.length === 0 ? (
        <p className="text-sm text-muted-fg">Sem estacionamentos.</p>
      ) : (
        <ul className="space-y-2">
          {client.lots.map((lot) => (
            <ClientLotRow
              key={lot.id}
              lot={lot}
              pricing={pricing}
              onExtend={onExtend}
              onArchive={onArchive}
              onUnarchive={onUnarchive}
              onResetCheckout={onResetCheckout}
              onToggleModule={onToggleModule}
              unarchive={unarchive}
              toggleModule={toggleModule}
              resetCheckout={resetCheckout}
            />
          ))}
        </ul>
      )}
    </CardContent>
  </Card>
);
